<style lang="scss" src='./WeatherStationThreshold.scss' scoped></style>
<template src="./WeatherStationThreshold.html"></template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";

import {
  getWeatherStations,
  getWeatherThresholds,
  updateWeatherThresholds,
} from "@/api/index";
import SecurityComponent from "@/components/SecurityComponent.vue";

export default {
  name: "WeatherStationThreshold",
  extends: SecurityComponent,
  components: {
    VueSlider,
  },

  data() {
    return {
      thresholds: this.G_getThresholds(),
      courseId: null,
      stations: [],
      station: null,
      thresholdList: null,
      loading: {
        thresholds: false,
        saving: false,
        undo: false,
      }
    };
  },

  computed: {
    sortedArray: function () {
      function compare(a, b) {
        if (a.alert_type.orden < b.alert_type.orden)return -1;
        if (a.alert_type.orden > b.alert_type.orden) return 1;
        return 0;
      }

      if (this.thresholdList) {
        return this.thresholdList.sort(compare);
      }
      return []
    },
  },

  methods: {
    saveThresholds() {
      this.loading.saving = true;
      const sensorThresholds = this.thresholdList.map((threshold) => {
        const data = {};
        data.alert_type_id = threshold.alert_type_id;

        if (threshold.value !== null && threshold.value !== '') {
          let type = typeof threshold.value;

          if (threshold.min !== null) {
            let min_val = threshold.value[0];
            
            if(this.$store.state.course.measurement_system == 'METRIC'){
              if(threshold.alert_type_id == 'AIR_TEMPERATURE' || threshold.alert_type_id == 'PRECIPITATION' ||
                 threshold.alert_type_id == 'WIND_GUST' || threshold.alert_type_id == 'HORIZONTAL_WIND_SPEED'){
                
                min_val = this.G_MetricToImperial({
                  value: min_val,
                  uom: threshold.alert_type.uom,
                })

              }
            }else if(this.$store.state.course.measurement_system == 'IMPERIAL'){
              if(threshold.alert_type_id == 'ET_RATE'){
                min_val = this.G_ImperialToMetric({
                  value: min_val,
                  uom: threshold.alert_type.uom,
                })
              }
            }

            data.min = min_val;
          }

          let max_value = null;
          if (threshold.max !== null && type === "object") {
            max_value = threshold.value[1];
          } else if (threshold.max !== null) {
            max_value = threshold.value;
          }

          if(max_value !== null){

            if(this.$store.state.course.measurement_system == 'METRIC'){
              if(threshold.alert_type_id == 'AIR_TEMPERATURE' || threshold.alert_type_id == 'PRECIPITATION' ||
                 threshold.alert_type_id == 'WIND_GUST' || threshold.alert_type_id == 'HORIZONTAL_WIND_SPEED'){
                
                max_value = this.G_MetricToImperial({
                  value: max_value,
                  uom: threshold.alert_type.uom,
                })

              }
            }else if(this.$store.state.course.measurement_system == 'IMPERIAL'){
              if(threshold.alert_type_id == 'ET_RATE'){
                max_value = this.G_ImperialToMetric({
                  value: max_value,
                  uom: threshold.alert_type.uom,
                })
              }
            }

            data.max = max_value;
          }
        }
        data.active = threshold.active;

        return data;
      });

      updateWeatherThresholds(this.station.station_id, sensorThresholds).then(
        () => {
          if (process.env.VUE_APP_SENTRY_ENV == "production") {
            this.$analytics.setCurrentScreen("Web Alerts Station Setup Save");
            this.$analytics.logEvent("web_alerts_station_setup_save");
          }

          this.$notify({
            text: "Thresholds updated",
            type: "success",
          });
        }
      ).finally(() => {
        this.loading.saving = false;
      });

      this.loading.saving = false;
    },

    async reset() {
      this.loading.undo = true;
      await this.loadThresholds(this.station.station_id);
      this.loading.undo = false;
    },

    loadStation() {
      this.loading.thresholds = true;
      getWeatherStations().then(async (stationsResp) => {
        if (!this.G_isEmptyArr(stationsResp)) {
          this.stations = stationsResp;
          await this.loadThresholds(this.stations[0].station_id);
          this.station = this.stations[0];
        }
      }).finally(() => {
        this.loading.thresholds = false;
      });
    },

    async loadThresholds(station_id) {
      this.loading.thresholds = true;
      await getWeatherThresholds(station_id).then((thresholdsResp) => {
        if (thresholdsResp) {
          thresholdsResp.forEach((t) => {
            if (t.alert_type.uom !== this.consts.UOM.UNKNOWN) {
              const minVal = this.G_getMeasurement({
                val: t.min,
                uom: t.alert_type.uom,
              });
              const maxVal = this.G_getMeasurement({
                val: t.max,
                uom: t.alert_type.uom,
              });
              t.value = t.min !== null ? [minVal, maxVal] : maxVal;

              let alertType = t.alert_type;
              const alert_min = alertType.min !== null  ? this.G_getMeasurement({
                val: alertType.min,
                uom: alertType.uom,
              }) : alertType.min;

              const alert_max = alertType.max !== null ? this.G_getMeasurement({
                val: alertType.max,
                uom: alertType.uom,
              }) : alertType.max;

              alertType.min = Math.ceil(alert_min);
              alertType.max = Math.ceil(alert_max);

              t.alert_type = alertType;

            }
          });

          this.thresholdList = thresholdsResp;
        }
      }).finally(() => {
        this.loading.thresholds = false;
      });;
    },

    onStationChange() {
      this.loadThresholds(this.station.station_id);
    },

    loadData() {
      this.loadStation();
    },
  },

  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Alerts Station Setup");
      this.$analytics.logEvent("web_alerts_station_setup");
    }

    this.loadData();
  },
};
</script>
